import { render, staticRenderFns } from "./peccancy-records.vue?vue&type=template&id=2dd00b9e&scoped=true&"
import script from "./peccancy-records.vue?vue&type=script&lang=js&"
export * from "./peccancy-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd00b9e",
  null
  
)

export default component.exports